// extracted by mini-css-extract-plugin
module.exports = {"icon":"PlatformIcon_icon__1xrY7"};